const headerMenu = [
  {
    type: "header menu",
    province: "",
    text: "Alberta",
    url: "/AB",
  },
  {
    type: "header menu",
    province: "",
    text: "British Columbia",
    url: "/BC",
  },
  {
    type: "header menu",
    province: "",
    text: "Ontario",
    url: "/ON",
  },
  {
    type: "header menu",
    province: "",
    text: "Yukon",
    url: "/YT",
  },

  {
    type: "header menu",
    province: "ON",
    text: "Select Province",
    url: "/",
  },
  {
    type: "header menu",
    province: "ON",
    text: "Ontario Home",
    url: "/ON",
  },
  {
    type: "header menu",
    province: "ON",
    text: "Transaction Checklists",
    url: "/ON/transaction-checklists",
  },
  {
    type: "header menu",
    province: "ON",
    text: "FORM 320/324 Checkboxes",
    url: "/ON/form-320",
  },
  {
    type: "header menu",
    province: "ON",
    text: "Common Forms",
    url: "/ON/common-forms",
  },
  {
    type: "header menu",
    province: "ON",
    text: "Clause Generator",
    url: "/ON/clause-generator",
  },
  {
    type: "header menu",
    province: "ON",
    text: "Transaction Best Practices",
    url: "/ON/transaction-best-practices",
  },
  {
    type: "header menu",
    province: "ON",
    text: "Office Procedures",
    url: "/ON/office-procedures",
  },
  {
    type: "header menu",
    province: "AB",
    text: "Select Province",
    url: "/",
  },
  {
    type: "header menu",
    province: "AB",
    text: "Alberta Home",
    url: "/AB",
  },
  {
    type: "header menu",
    province: "AB",
    text: "Transaction Checklists",
    url: "/AB/transaction-checklists",
  },
  {
    type: "header menu",
    province: "AB",
    text: "Deal Sheet / Calculator",
    url: "https://www.expagentcentre.ca/commission-calculator",
  },
  {
    type: "header menu",
    province: "AB",
    text: "Common Forms",
    url: "/AB/common-forms",
  },
  {
    type: "header menu",
    province: "AB",
    text: "Real Estate Act Best Practices",
    url: "/AB/best-practices",
  },
  {
    type: "header menu",
    province: "AB",
    text: "Office Procedures",
    url: "/AB/office-procedures",
  },
  {
    type: "header menu",
    province: "YT",
    text: "Select Province",
    url: "/",
  },
  {
    type: "header menu",
    province: "YT",
    text: "Yukon Home",
    url: "/YT",
  },
  {
    type: "header menu",
    province: "YT",
    text: "Transaction Checklists",
    url: "/YT/transaction-checklists",
  },
  {
    type: "header menu",
    province: "YT",
    text: "Common Forms",
    url: "/YT/common-forms",
  },
  {
    type: "header menu",
    province: "YT",
    text: "Real Estate Act Best Practices",
    url: "/YT/best-practices",
  },
  {
    type: "header menu",
    province: "YT",
    text: "Office Procedures",
    url: "/YT/office-procedures",
  },
  {
    type: "header menu",
    province: "BC",
    text: "Select Province",
    url: "/",
  },
  {
    type: "header menu",
    province: "BC",
    text: "British Columbia Home",
    url: "/BC",
  },
  {
    type: "header menu",
    province: "BC",
    text: "Transaction Checklists",
    url: "/BC/transaction-checklists",
  },
  {
    type: "header menu",
    province: "BC",
    text: "Deal Sheet / Calculator",
    url: "https://www.expagentcentre.ca/commission-calculator",
  },
  {
    type: "header menu",
    province: "BC",
    text: "Common Forms",
    url: "/BC/common-forms",
  },
  {
    type: "header menu",
    province: "BC",
    text: "Transaction Best Practices",
    url: "/BC/best-practices",
  },
  {
    type: "header menu",
    province: "BC",
    text: "Office Procedures",
    url: "/BC/office-procedures",
  },
  {
    type: "header menu",
    province: "NL",
    text: "Select Province",
    url: "/",
  },
  {
    type: "header menu",
    province: "NL",
    text: "Newfoundland Home",
    url: "/NL",
  },
  {
    type: "header menu",
    province: "NL",
    text: "Transaction Checklists",
    url: "/NL/transaction-checklists",
  },
  {
    type: "header menu",
    province: "NL",
    text: "Common Forms",
    url: "/NL/common-forms",
  },
  {
    type: "header menu",
    province: "NL",
    text: "Transaction Best Practices",
    url: "/NL/transaction-best-practices",
  },
  {
    type: "header menu",
    province: "NL",
    text: "Office Procedures",
    url: "/NL/office-procedures",
  },
  {
    type: "header menu",
    province: "NB",
    text: "Select Province",
    url: "/",
  },
  {
    type: "header menu",
    province: "NB",
    text: "New Brunswick Home",
    url: "/NB",
  },
  {
    type: "header menu",
    province: "NB",
    text: "Transaction Checklists",
    url: "/NB/transaction-checklists",
  },
  {
    type: "header menu",
    province: "NB",
    text: "Common Forms",
    url: "/NB/common-forms",
  },
  {
    type: "header menu",
    province: "NB",
    text: "Transaction Best Practices",
    url: "/NB/transaction-best-practices",
  },
  {
    type: "header menu",
    province: "NB",
    text: "Office Procedures",
    url: "/NB/office-procedures",
  },
  {
    type: "header menu",
    province: "MB",
    text: "Select Province",
    url: "/",
  },
  {
    type: "header menu",
    province: "MB",
    text: "Manitoba Home",
    url: "/MB",
  },
  {
    type: "header menu",
    province: "MB",
    text: "Transaction Checklists",
    url: "/MB/transaction-checklists",
  },
  {
    type: "header menu",
    province: "MB",
    text: "Common Forms",
    url: "/MB/common-forms",
  },
  {
    type: "header menu",
    province: "MB",
    text: "Transaction Best Practices",
    url: "/MB/transaction-best-practices",
  },
  {
    type: "header menu",
    province: "MB",
    text: "Office Procedures",
    url: "/MB/office-procedures",
  },
  {
    type: "header menu",
    province: "SK",
    text: "Select Province",
    url: "/",
  },
  {
    type: "header menu",
    province: "SK",
    text: "Saskatchewan Home",
    url: "/SK",
  },
  {
    type: "header menu",
    province: "SK",
    text: "Transaction Checklists",
    url: "/SK/transaction-checklists",
  },
  {
    type: "header menu",
    province: "SK",
    text: "Common Forms",
    url: "/SK/common-forms",
  },
  {
    type: "header menu",
    province: "SK",
    text: "Transaction Best Practices",
    url: "/SK/transaction-best-practices",
  },
  {
    type: "header menu",
    province: "SK",
    text: "Office Procedures",
    url: "/SK/office-procedures",
  },
  {
    type: "header menu",
    province: "QC",
    text: "Select Province",
    url: "/",
  },
  {
    type: "header menu",
    province: "QC",
    text: "Quebec Home",
    url: "/QC",
  },
  {
    type: "header menu",
    province: "QC",
    text: "Transaction Checklists",
    url: "/QC/transaction-checklists",
  },
  {
    type: "header menu",
    province: "QC",
    text: "Common Forms",
    url: "/QC/common-forms",
  },
  {
    type: "header menu",
    province: "QC",
    text: "Transaction Best Practices",
    url: "/QC/transaction-best-practices",
  },
  {
    type: "header menu",
    province: "QC",
    text: "Office Procedures",
    url: "/QC/office-procedures",
  },
];

export default headerMenu;

/*

 {
    type: "header menu",
    province: "",
    text: "New Brunswick",
    url: "/NB",
  },
  {
    type: "header menu",
    province: "",
    text: "Manitoba",
    url: "/MB",
  },
  {
    type: "header menu",
    province: "",
    text: "Saskatchewan",
    url: "/SK",
  },
  {
    type: "header menu",
    province: "",
    text: "Quebec",
    url: "/QC",
  },

  */
